module.exports = __webpack_public_path__ + "img/diamond-2.6c2f9f26.png";